import React from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone-uploader';
import BatchUploadPage from './BatchUploadPage';
import CustomInput from './AddFileButton';
import { getAgencies } from '../../../actions/agency';
import { getCampaigns } from '../../../actions/campaign';

import 'react-dropzone-uploader/dist/styles.css';

class UploadTile extends React.PureComponent {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: 'CLEAR_BATCH_ERROR' });
    getAgencies();
    getCampaigns();
  }

  getUploadParams = () => {
    const {
      token,
      site,
      tab,
      previewing,
      agencyId,
      campaignId,
    } = this.props;
    const step = previewing ? 'preview' : 'process';
    const type = tab === 'license' ? 'state' : tab;

    const fields = {
      step,
      file_type: type,
    };
    if (agencyId) fields.agency_id = agencyId;
    if (campaignId) fields.campaign_ids = campaignId;

    return {
      method: 'post',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/batch-updates/?site=${site}`,
      headers: { Authorization: `Token ${token}` },
      fields,
    };
  };

  validateBatchConfiguration = () => {
    const {
      tab,
      agencyId,
      campaignId,
      campaignFeature,
    } = this.props;
    let missingConfiguration = false;
    if (tab === 'agent') {
      missingConfiguration = (agencyId === '' || agencyId === null);
    } else if (tab === 'leads') {
      if (agencyId === '' || agencyId === null) missingConfiguration = true;
      if (campaignFeature && (campaignId === '' || campaignId === null)) missingConfiguration = true;
    }
    return missingConfiguration;
  };

  handleChangeStatus = ({
    remove,
    xhr,
  }, status) => {
    const { dispatch, tab } = this.props;
    switch (status) {
      case 'preparing':
        dispatch({ type: 'CLEAR_BATCH_RESULTS_SAVE_MODE' });
        break;
      case 'getting_upload_params':
        break;
      case 'uploading':
        break;
      case 'headers_received':
        break;
      case 'ready':
        dispatch({ type: 'UPLOAD_BUSY' });
        break;
      case 'done': {
        dispatch({ type: 'SET_UPLOAD_STATUS', status });

        if (tab === 'leads' || tab === 'leads_reassignment') {
          dispatch({ type: 'SET_LEADS_UPLOAD_STATUS', data: xhr.response });
        } else {
          const results = JSON.parse(xhr.response);
          dispatch({ type: 'LOAD_BATCH_RESULTS', ...results });
        }
        remove();
        break;
      }
      case 'removed':
        dispatch({ type: 'UPLOAD_READY' });
        break;
      case 'error_upload':
        break;
      case 'exception_upload':
        break;
      case 'error_upload_params':
        break;
      case 'error_validation':
        dispatch({ type: 'SET_BATCH_ERROR', error: status });
        remove();
        break;
      case 'error_file_size':
        break;
      case 'rejected_max_files':
        break;
      case 'rejected_file_type':
        dispatch({ type: 'SET_BATCH_ERROR', error: status });
        break;
      case 'aborted':
        break;
      default:
        dispatch({ type: 'CLEAR_BATCH_RESULTS' });
        break;
    }

    dispatch({ type: 'SET_UPLOAD_STATUS', status });
    dispatch({ type: 'CLOSE_DROPZONE' });
  };

  render() {
    return (
      <Dropzone
        getUploadParams={this.getUploadParams}
        onChangeStatus={this.handleChangeStatus}
        validate={this.validateBatchConfiguration}
        accept=".csv"
        LayoutComponent={BatchUploadPage}
        InputComponent={CustomInput}
        maxFiles="1"
      />
    );
  }
}

const mapStateToProps = (store) => ({
  tab: store.batch.tab,
  token: store.auth.token,
  site: store.theme.site,
  previewing: store.batch.previewing,
  agencyId: store.batchUI.agencyId,
  campaignId: store.batchUI.campaignId,
  campaignFeature: store.theme.features.campaigns,
});

export default connect(mapStateToProps)(UploadTile);
